<template>
  <Loader class="marketing-view" theme="default" :delay="0" :value="initializing">
    <Card v-if="!initializing" thumbnail="/images/ads/banner.png">
      <div class="card__title">
        Annonsering i Kvass
        <Badge value="Nyhet" theme="primary" class="ml-1" />
      </div>

      <p>
        Annonseringsverktøyet i Kvass lar deg annonsere nyboligprosjektene dine i digitale kanaler på egenhånd – når du
        vil, og hvor du vil – direkte fra Kvass-plattformen.
      </p>

      <p>
        Fram til 17. mai kan du aktivere og teste annonsering for ett av nyboligprosjektene dine i Kvass, helt gratis og
        uforpliktende!
      </p>

      <p>Interessert? Trykk på knappen nedenfor for å komme i gang!</p>

      <template #footer>
        <ButtonComponent
          label="Prøv annonsering"
          theme="primary"
          icon="fa-pro-light:bullseye-pointer"
          @click="next"
          :promise="promises.next"
        />
      </template>
    </Card>
  </Loader>
</template>

<script>
import { LoaderComponent as Loader } from 'vue-elder-loader'
import Card from '@/components/Card'
import Badge from '@/components/Badge'
import { ButtonComponent } from 'vue-elder-button'
import { DropdownComponent } from 'vue-elder-dropdown'
import fetch from '@/fetch'

export default {
  data() {
    return {
      promises: {
        check: null,
        next: null,
      },
      initializing: true,
      destination: null,
    }
  },
  methods: {
    next() {
      if (!this.destination) return
      window.location.replace(this.destination)
    },
    check() {
      let status
      this.promises.check = fetch('/api/marketing/auth?redirect=manual')
        .then(res => {
          status = res.status
          return res.text()
        })
        .then(url => {
          this.destination = url
          if (status === 200) return this.next()
          this.initializing = false
        })
        .catch(err => {
          this.initializing = false
        })
    },
  },
  created() {
    if (this.$store.state.enums.MarketingDisabled) return this.$router.replace('/')
    this.check()
  },
  metaInfo: {
    title: 'Annonsering',
  },
  components: {
    Loader,
    Card,
    Badge,
    ButtonComponent,
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.marketing-view {
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(black, 0.05);

  .card {
    max-width: 65ch;
    line-height: 1.5;

    &__header {
      aspect-ratio: 16 / 9;
    }
  }

  table {
    min-width: 350px;
  }
}
</style>
